import { useState } from "react";
import FormAssociations from "views/admin/associations/components/FormAssociations";
import TableAssociations from "views/admin/associations/components/TableAssociations";
import SectionTitle from "components/sectionTitle";

const Associations = () => {
  const [editData, setEditData] = useState(null);  // Estado para la especialidad que se va a editar

  const handleEdit = (dataEdit) => {
    setEditData(dataEdit);
  };

  return (
    <div>
      <SectionTitle eyebrow="Configuración">Asociaciones</SectionTitle>
      <div className="grid grid-cols-1 items-start gap-5 lg:grid-cols-3">
        <div className="lg:col-span-1">
          <FormAssociations editData={editData} />
        </div>
        <div className="lg:col-span-2">
          <TableAssociations onEdit={handleEdit} />
        </div>
      </div>
    </div>
  );
};

export default Associations;
